import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

export interface UploadSucess {
  body: number;
  headers: any;
  ok: boolean;
  status: number;
  statusText: string;
  type: number;
  url: string;
}
@Injectable({
  providedIn: 'root'
})

export class UploadService {

  public URL = `${environment.protheus}/upload`;

  constructor(private http: HttpClient) { }

  uploadHandler(event, obj) {
    event.data = { ...obj };
    return event;
  }

  listFiles(tabela: string, registro: string) {
    return this.http.get(`${environment.protheus}/conhecimento?tabela=${tabela}&registro=${registro}`);
  }

  downloadFile(registro: any) {
    return this.http.get(`${environment.protheus}/download/${registro}`, { responseType: 'blob' });
  }
}
